
import * as handlebars_family from "../handlebars_family.ts";

const TPL = handlebars_family.addTemplate("modal/email_validatesnackbar",{"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"fw-snack\" data-fw-onclick=\"emailvalidate|"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"email") : depth0), depth0))
    + "\"><icon>"
    + container.escapeExpression((lookupProperty(helpers,"iconlib")||(depth0 && lookupProperty(depth0,"iconlib"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"ic_error",{"name":"iconlib","hash":{},"data":data,"loc":{"start":{"line":1,"column":72},"end":{"line":1,"column":94}}}))
    + "</icon> "
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"emailvalidate.snack",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":102},"end":{"line":1,"column":134}}})) != null ? stack1 : "")
    + " <icon style=\"float:right\" data-fw-onclick=\"snackclose\">"
    + container.escapeExpression((lookupProperty(helpers,"iconlib")||(depth0 && lookupProperty(depth0,"iconlib"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"ic_close",{"name":"iconlib","hash":{},"data":data,"loc":{"start":{"line":1,"column":190},"end":{"line":1,"column":212}}}))
    + "</icon></div>";
},"useData":true});
export default TPL;